import { useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { updateChatIdInUrl } from '../actions/chatWindow/updateChatIdInUrl';
import { hostTypeSelector } from '../selectors/hostTypeSelector';
import { setMobileActiveSide } from '../actions/mobileSide/actions';
import { closeChat } from '../actions/chatWindow/actions';
import { openChatFromListItem } from '../actions/chatList';
import { EMobileLayoutActiveSide } from '../types/mobileSide';
import { useDeviceInfo } from '@cian/ui-kit';
import { isIframeHostType } from '../utils/isIframeHostType';
import { noop } from '../utils/noop';
import { currentOpenedChatIdSelector } from '../selectors';

export const useUpdateChatIdInUrl = () => {
  const chatId = useSelector(currentOpenedChatIdSelector);
  const hostType = useSelector(hostTypeSelector);
  const { isDesktop } = useDeviceInfo();
  const dispatch = useDispatch();

  const isFrame = isIframeHostType(hostType);

  const chatIdRef = useRef(chatId);

  useEffect(() => {
    if (isFrame) {
      return;
    }

    chatIdRef.current = chatId;

    dispatch(updateChatIdInUrl(chatId));
  }, [chatId, isFrame, isDesktop, dispatch]);

  useEffect(() => {
    if (isFrame || isDesktop) {
      return noop;
    }

    const handler = () => {
      const queryParams = new URLSearchParams(window.location.search);
      const queryChatId = queryParams.get('chatId');
      const currentChatId = chatIdRef.current;

      /** Если переходим вперед к чату, то имитируем открытие чата */
      if (queryChatId && queryChatId !== currentChatId) {
        dispatch(openChatFromListItem({ chatId: queryChatId, isMobile: true }));

        return;
      }

      /** При переходе назад закрываем чат и меняем view */
      if (!queryChatId && currentChatId) {
        dispatch(closeChat());
        dispatch(setMobileActiveSide(EMobileLayoutActiveSide.Left));
      }
    };

    window.addEventListener('popstate', handler);

    return () => {
      window.removeEventListener('popstate', handler);
    };
  }, [isFrame, isDesktop, dispatch]);
};
